import { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import { useHistory } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'

import Checkbox from '../Checkbox'
import ItemList from './ItemList'
import Pagination from 'components/Pagination'

import {
  getPaginatedItems,
  getTotalItemsCount,
} from 'store/Items/selector'
import { loadFilteredItems } from 'store/Items/actions'
import { setQueryStringParameters } from 'store/AppState/actions'

const GlobalItems = ({ queryStringParameters, isLoading }) => {
  const [selectAllItems, setSelectAllItems] = useState(false)
  const [itemsSelected, setItemsSelected] = useState([])

  const history = useHistory()
  const dispatch = useDispatch()
  const { pathname } = useLocation()

  const paginatedItems = useSelector(getPaginatedItems)
  const totalItemsCount = useSelector(getTotalItemsCount)

  useEffect(() => {
    selectAllItemsHandler()
  }, [totalItemsCount, selectAllItems])

  const selectAllItemsHandler = () => {
    if (!selectAllItems || totalItemsCount === itemsSelected.length) {
      setItemsSelected([])
    } else {
      let allUuids = []

      paginatedItems.map(
        ({ uuid }) => (allUuids = [...allUuids, uuid])
      )
      setItemsSelected([...allUuids])
    }
  }

  const handleChangeRowsPerPage = (event) => {
    handleLoadNewItems({
      ...queryStringParameters,
      page: 1,
      per: Number(event.target.value),
    })
  }

  const handleClickPage = (page) => {
    handleLoadNewItems({
      ...queryStringParameters,
      page: page,
    })
  }

  const handleLoadNewItems = (data) => {
    dispatch(loadFilteredItems(data))
    dispatch(setQueryStringParameters(data, pathname))
  }

  const selectedItemsBulkAction = () => {
    const location = {
      pathname: `/items`,
      state: { itemsSelected, itemUuid: 'bulk' },
    }

    if (itemsSelected.length === 1)
      history.push({ state: { itemUuid: itemsSelected[0] } })

    if (itemsSelected.length > 1) history.push(location)
  }

  return (
    <>
      <div className="items">
        <div className="header">
          <ul className="header__menu">
            <li className="header__menu-item -small">
              <Checkbox
                checked={selectAllItems}
                onChange={() => setSelectAllItems(!selectAllItems)}
              />
            </li>
            <li className="header__menu-item">Name</li>
            <li className="header__menu-item">Image</li>
            <li className="header__menu-item">Price</li>
            <li className="header__menu-item">SKU</li>
            <li className="header__menu-item">Availability</li>
          </ul>
        </div>
        <ItemList
          data={paginatedItems}
          history={history}
          itemsSelected={itemsSelected}
          setItemsSelected={setItemsSelected}
          isLoading={isLoading}
        />
        <section className="footer">
          <Pagination
            selectedItemsBulkAction={selectedItemsBulkAction}
            selectedItemsBulkAmount={itemsSelected.length}
            totalItemsCount={totalItemsCount}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleClickPage={handleClickPage}
            pageNumber={queryStringParameters?.page}
            rowsPerPage={queryStringParameters?.per}
          />
        </section>
      </div>
    </>
  )
}

GlobalItems.defaultProps = {
  paginationConfig: {
    per: 25,
    page: 1,
  },
}

GlobalItems.propTypes = {
  queryStringParameters: PropTypes.shape({
    per: PropTypes.number,
    page: PropTypes.number,
    searchBy: PropTypes.string,
    searchFor: PropTypes.string,
    venueUuid: PropTypes.string,
  }),
}

export default GlobalItems
